/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import XInput from "vux/src/components/x-input/index.vue";
import Group from "vux/src/components/group/index.vue";
import XAddress from "vux/src/components/x-address/index.vue";
import ChinaAddressV4Data from "vux/src/datas/china_address_v4.json";
import value2name from "vux/src/filters/value2name.js";
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import { GETTER_MALL_ADDRESSLIST, ACTION_MALL_ADDRESSLIST } from '@/store/mutation_types';
import { Address, AddressNew, AddressDetele, AddressModify } from '@/api/mall';
export default {
  data: function data() {
    return {
      isEdit: true,
      fullAddress: '',
      postCode: '',
      addressData: [],
      showAddress: false,
      userAddressId: '',
      value: [],
      nowAddress: {}
    };
  },
  created: function created() {
    var _this = this;

    Address().then(function (data) {
      // data.pop();
      _this.addressData = data;
      _this.isEdit = _this.$route.query.isEdit || true;
      _this.userAddressId = _this.$route.query.userAddressId || '';
      var v = [];

      if (_this.userAddressId) {
        _this.nowAddress = _this.addressList.find(function (x) {
          return x.userAddressId == _this.userAddressId;
        });
      } else {
        _this.nowAddress = {};
      }

      var nowAddress = _this.nowAddress;

      if (nowAddress.userName) {
        v[0] = nowAddress.provinceCode;
        v[1] = nowAddress.cityCode;
        v[2] = nowAddress.districtCode;
      }

      _this.value = v;
    });
  },
  components: {
    XInput: XInput,
    Group: Group,
    XAddress: XAddress,
    ChinaAddressV4Data: ChinaAddressV4Data
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    addressList: GETTER_MALL_ADDRESSLIST
  })), {}, {
    isCanSub: function isCanSub() {
      var nowAddress = this.nowAddress;

      if (!nowAddress) {
        return false;
      }

      if (nowAddress.userName && nowAddress.phoneNumber && this.value.length > 0 && nowAddress.detailAddress) {
        return true;
      } else {
        return false;
      }
    },
    flag: function flag() {
      //0:新建；1：修改
      if (!this.userAddressId) {
        return 0;
      } else {
        return 1;
      }
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions({
    actionAddressList: ACTION_MALL_ADDRESSLIST
  })), {}, {
    //地址提交保存
    submitAddress: function submitAddress() {
      var _this2 = this;

      if (!this.isCanSub) {
        return;
      }

      var addressNameList = value2name(this.value, this.addressData, "|").split("|");
      var params = {};
      var nowAddress = this.nowAddress;
      var phone = nowAddress.phoneNumber;

      if (!this.$refs.phone.valid) {
        Public.tips({
          text: '请输入正确的电话格式'
        });
        return;
      }

      console.log(addressNameList);
      params.userName = nowAddress.userName;
      params.phoneNumber = nowAddress.phoneNumber;
      params.provinceCode = this.value[0];
      params.cityCode = this.value[1];
      params.districtCode = this.value[2];
      params.provinceName = addressNameList[0];
      params.cityName = addressNameList[1];
      params.districtName = addressNameList[2];
      params.detailAddress = nowAddress.detailAddress;
      params.postCode = this.postCode;

      if (this.flag == 0) {
        AddressNew(params).then(function (data) {
          _this2.reloadAddress();
        });
      } else if (this.flag == 1) {
        params.userAddressId = this.userAddressId;
        AddressModify(params).then(function (data) {
          Public.tips({
            text: '修改成功'
          }).then(function () {
            _this2.reloadAddress();
          });
        });
      }
    },
    //地址删除
    deleteAddress: function deleteAddress() {
      var _this3 = this;

      var userAddressId = this.userAddressId;
      AddressDetele(userAddressId).then(function (data) {
        Public.tips({
          text: '删除成功'
        }).then(function () {
          _this3.reloadAddress();
        });
      });
    },
    reloadAddress: function reloadAddress() {
      // this.actionAddressList();
      this.$router.back(-1);
    }
  })
};